import * as React from "react";
import finalTick from "../../assets/icons/finalTick.svg";
import "./KYCSubmit.scss";
import { downloadForm } from "../POA/Poa";
import GlobalStore from "../store/globalStore";
import Button from "../UI/Button/Button";
import DeviceContext from "../Services/identifyDevice";
import { containerUrl, loginUrl } from "../../components/utils/constants";
import { isSafariBrowser, localStorageGetItem } from "../Services/globalService";
import {
  AGetClientAccountCode,
  AGetRMEsignVerificationUrlDetails,
} from "../Services/dashboard/eSignApiServices";
import { IListObj, ITokenObj } from "../types/genericTypes";
import { decryptJwtToken } from "../Services/dashboard/encryptionNew";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import mixpanelService from "../Services/mixpanelService";
import { webFlowEvents } from "../../config/mixpanelEvents";

const KYCSubmit = () => {
  // const history = useHistory();
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [linkSend, setLinkSend] = React.useState<boolean>(false);
  const [errCode, setErrCode] = React.useState<number | string>();
  const [displayTitleList, setDisplayTitleList] = React.useState<
    Array<{ display: string; value: string }>
  >([]);
  function getStarted() {
    //gtmService({ action: "FINAL_STATUS", label: "Get_Started" });
    if (DeviceContext().isDesktop) {
      window.location.href = loginUrl + "user-guide/web";
    } else {
      if (isSafariBrowser()) {
        window.location.href =
          "https://app.appsflyer.com/id1031657545?pid=newEW";
      } else {
        window.location.href = "https://edel.onelink.me/3126852515/a4df843a";
      }
    }
  }
  const sendToAPILink = () => {
    setLinkSend(false);
    const clientPartialDetails_ao = JSON.parse(
      localStorageGetItem("clientPartialDetails_ao") || "{}"
    );
    let userId = "0";
    const tokenObj: string = decryptJwtToken(clientPartialDetails_ao?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = tokenMainObj?.UserId?.toString();
    }
    AGetRMEsignVerificationUrlDetails(
      getEsignUrl,
      clientPartialDetails_ao?.applicationId
        ? clientPartialDetails_ao?.applicationId
        : GlobalStore.applicationID,
      1,
      clientPartialDetails_ao.accountcategory
        ? clientPartialDetails_ao.accountcategory
        : 0,
      parseInt(userId)
    );
  };
  function getEsignUrl(res: any) {
    if (!res || res.error) {
      //   setErrCode(res.error);
      // gtmService({ action: "GetEsignLink", label: "ERROR || ERR117" });
      setIsLoading(false);
    } else {
      if (
        (res.data.Code == 200 || res.data.Code == 201) &&
        res.data.Data.EsignLink !== null
      ) {
        const encryptedUrl = res.data.Data.EsignLink;
        setLinkSend(true);
        // gtmService({ action: "E_SIGN | E_SIGN", label: "Step_Complete" });

        // Clevertap event while user choose for e-sign
        // esignCleverTapEvent(true);
        // Clevertap ends

        //   window.location.href = encryptedUrl;
      } else {
        var allErrorsString = "";
        if (res.data.Data.FormValidationSummary.length > 0) {
          setLinkSend(false);
          res.data.Data.FormValidationSummary.forEach(
            (element: any, i: number) => {
              if (i === 0) allErrorsString = element.FormValidations;
              else allErrorsString += `, ${element.FormValidations}`;
            }
          );
        }
        setErrCode(res.data.Data.FormValidationSummary[0].FormValidations);
        setIsLoading(false);
      }
    }
  }

  React.useEffect(() => {
    const clientPartialDetails_ao = JSON.parse(
      localStorageGetItem("clientPartialDetails_ao") || "{}"
    );
    if (
      clientPartialDetails_ao?.applicationId == "" ||
      clientPartialDetails_ao?.applicationId == null ||
      clientPartialDetails_ao?.applicationId == undefined
    ) {
      alert(
        "Please restart or check your status to continue with your Account Opening process as current session is expired."
      );
      // history.push(containerUrl.registration);
      navigate(containerUrl.registration)
      return;
    } else {
      mixpanelService({
        event: webFlowEvents.finalSubmission.SUBMITTED,
        completion_type: "kyc_completed",
      });
      AGetClientAccountCode(
        getClientDetails,
        clientPartialDetails_ao?.applicationId
          ? clientPartialDetails_ao?.applicationId
          : GlobalStore.applicationID
      );
    }
  }, []);
  function getClientDetails(res: any) {
    if (!res || res.error) {
    } else {
      const responseObj = JSON.parse(res?.data ? res?.data : "[]");
      const clientPartialDetails_ao = JSON.parse(
        localStorageGetItem("clientPartialDetails_ao") || "{}"
      );
      if (responseObj && responseObj.dpid) {
        let holderName = responseObj.holderfullname
          ? responseObj.holderfullname
          : clientPartialDetails_ao.PANName
          ? clientPartialDetails_ao.PANName
          : "";
        let mobile = responseObj.mobileno
          ? responseObj.mobileno
          : clientPartialDetails_ao.mobile
          ? clientPartialDetails_ao.mobile
          : "";
        let email = responseObj.emailid
          ? responseObj.emailid
          : clientPartialDetails_ao.emailID
          ? clientPartialDetails_ao.emailID
          : "";
        const displayInfo: Array<any> = [];
        if (
          responseObj?.applicationid !== null &&
          responseObj?.applicationid !== undefined &&
          responseObj?.applicationid !== ""
        ) {
          displayInfo.push({
            display: "Account Code",
            value: responseObj?.applicationid,
          });
        }

        // if (
        //   holderName !== null &&
        //   holderName !== undefined &&
        //   holderName !== ""
        // ) {
        //   displayInfo.push({ display: "Form ID", value: holderName });
        // }

        if (email !== null && email !== undefined && email !== "") {
          displayInfo.push({ display: "Email ID", value: email });
        }

        if (mobile !== null && mobile !== undefined && mobile !== "") {
          displayInfo.push({
            display: "Mobile Number",
            value: mobile,
          });
        }

        if (
          responseObj?.dpid !== null &&
          responseObj?.dpid !== undefined &&
          responseObj?.dpid !== ""
        ) {
          displayInfo.push({ display: "DP ID", value: responseObj?.dpid });
        }

        // setTime(responseObj.esigncompletedtime);
        setDisplayTitleList(displayInfo);
      } else {
        let holderName = responseObj.holderfullname
          ? responseObj.holderfullname
          : clientPartialDetails_ao.PANName
          ? clientPartialDetails_ao.PANName
          : "";
        let mobile = responseObj.mobileno
          ? responseObj.mobileno
          : clientPartialDetails_ao.mobile
          ? clientPartialDetails_ao.mobile
          : "";
        let email = responseObj.emailid
          ? responseObj.emailid
          : clientPartialDetails_ao.emailID
          ? clientPartialDetails_ao.emailID
          : "";
        const displayInfo: Array<any> = [];
        if (
          responseObj?.applicationid !== null &&
          responseObj?.applicationid !== undefined &&
          responseObj?.applicationid !== ""
        ) {
          displayInfo.push({
            display: "Account Code",
            value: responseObj?.applicationid,
          });
        }

        // if (
        //   holderName !== null &&
        //   holderName !== undefined &&
        //   holderName !== ""
        // ) {
        //   displayInfo.push({ display: "Form ID", value: holderName });
        // }

        if (email !== null && email !== undefined && email !== "") {
          displayInfo.push({ display: "Email ID", value: email });
        }

        if (mobile !== null && mobile !== undefined && mobile !== "") {
          displayInfo.push({
            display: "Mobile Number",
            value: mobile,
          });
        }

        if (
          responseObj?.dpid !== null &&
          responseObj?.dpid !== undefined &&
          responseObj?.dpid !== ""
        ) {
          displayInfo.push({ display: "DP ID", value: responseObj?.dpid });
        }

        // setTime(responseObj.esigncompletedtime);
        setDisplayTitleList(displayInfo);
      }
    }
  }
  React.useEffect(() => {
    if (displayTitleList.length > 0) {
      window.sessionStorage.removeItem("clientPartialDetails_ao");
    }
  }, [displayTitleList]);
  return (
    <div className="kycsubmit">
      <div className="final-logo-section">
        <img src={finalTick} alt="Success" className="pfImg" />
      </div>
      <div className="checkStatusHeading">
        <h2>KYC verification completed</h2>
      </div>
      <div className="checkSubStatusHeading">
        KYC request raised for the client has been successfully approved. Client
        has been sent authentication link on his/her registered Email ID with
        us.
      </div>
      <div className="clientStepsInfo">
        {displayTitleList &&
          displayTitleList?.length > 0 &&
          displayTitleList.map((record) => {
            return (
              <div className="div-contents-new">
                <span className="display-content"> {record?.display}</span>
                <span className="value-content">{record?.value}</span>
              </div>
            );
          })}
      </div>
      {/* <div className="downloadLink">
        <p className="downloadLbl">You can download your POA form</p>
        <label
          className="hereLbl"
          onClick={() => {
            //   gtmService({ action: "FINAL_STATUS", label: "Download_form" });
            downloadForm(
              `EsignPoa_${GlobalStore.applicationID}`,
              setIsLoading,
              () => {}
            );
          }}
        >
          here
        </label>
      </div> */}
      <div className="startBtn">
        <Button
          btnName="Resend Link"
          isLoading={displayTitleList.length <= 0}
          onClick={() => {
            // getStarted();
            sendToAPILink();
          }}
        />
      </div>
      {linkSend && (
        <div className="checkSubStatusHeading">Link Send Successfully</div>
      )}
    </div>
  );
};

export default KYCSubmit;
